import { makeAutoObservable } from 'mobx'
import { openApi } from "../../../../helpers/request"
import { GatewaySplitRow } from "../../../../components/GatewaySplitEditor"

class WarehouseSplitController {

  list: any[] = []
  render: boolean = false

  constructor() {
    makeAutoObservable(this)
  }

  get() {
    return openApi('get', '/warehouse_split')
      .then((result: any) => {
        this.list = result.data
        this.render = true
      })
      .catch(error => console.log(error.response))
  }

  rowsFor(warehouseId: number, context: string): GatewaySplitRow[] {
    return this.list
      .filter((row: any) => row.warehouse_id === warehouseId && row.context === context)
      .map((row: any) => ({ gateway_id: row.payment_gateway_id, percent: row.percent }))
  }

  save(warehouseId: number, context: string, rows: GatewaySplitRow[]) {
    const data = new FormData()
    data.append('warehouse_id', `${warehouseId}`)
    data.append('context', context)
    data.append('rows', JSON.stringify(rows))

    return openApi('post', '/warehouse_split', data)
      .then(() => this.get())
  }
}

export default new WarehouseSplitController()
